import React from "react";
import { Form } from "react-bulma-components";

const { Control, Select } = Form;

/* A simple selection widget for a small fixed number of options where we
  don't need the full power and flexibility of our enhancedSelect component */

export function SimpleSelect({
  currentValue,
  setValue,
  allowDeselection,
  // Values may be specified as a list of value objects with id/label
  // properties, or as a separate list of values and labels
  valueObjects,
  values = valueObjects.map((v) => v.id),
  labels = Object.fromEntries(valueObjects.map((v) => [v.id, v.label])),
  // If true, the string context of the selected id will be turned back to
  // a number before calling setValue
  alwaysNumeric,
}) {
  return (
    <Control>
      <Select
        value={currentValue ?? ""}
        onChange={(event) => {
          const rawValue = event.target.value;
          const value =
            rawValue === ""
              ? null
              : alwaysNumeric
              ? Number(rawValue)
              : rawValue;
          setValue(value);
        }}
      >
        {allowDeselection || currentValue === null ? (
          <option key="" value="">
            - please select -
          </option>
        ) : null}
        {values.map((v) => (
          <option key={v} value={v}>
            {labels[v]}
          </option>
        ))}
      </Select>
    </Control>
  );
}

export default SimpleSelect;
